import React, { useState, useEffect, useContext } from "react";
import { BsPlayCircle } from "react-icons/bs";
import pic from "./shield.png";
import "./CustomerFormStyle.css";
import { message, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { onecodeAPI } from "../AppConfig";
import { useSearchParams, useNavigate } from "react-router-dom";
import WatchVideo from "./WatchVideo";
import { useTranslation } from "react-i18next";
import CustomInput from "./CustomInput";
import { useFormik } from "formik";
import DropDown from "./DropDown";
import _ from "lodash";
import * as Yup from "yup";
import { Context } from "../App";

export default function PanInput({ setCurrentScreen, currentScreen }) {
  // states
  const [pan, setPan] = useState("");
  const [isPan, setIsPan] = useState(true);
  const [isValid, setIsValid] = useState(true);
  const [panError, setPanError] = useState("");
  const [creditReportCheck, setCreditReportCheck] = useState(true);
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [modeOfSalaryOptions, setModeOfSalaryOptions] = useState([]);
  const [employmentTypeOptions, setEmploymentTypeOptions] = useState([]);
  const [hasCriteriaFields, setHasCriteriaFields] = useState(false);
  const [searchedPincodeList, setSearchedPincodeList] = useState([]);
  const [selectedEmploymentType, setSelectedEmploymentType] = useState(null);
 

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const { isMyTeamsFlow } = useContext(Context);


  const panRegex = /(^([a-zA-Z]{5})([0-9]{4})([a-zA-Z]{1})$)/;
  const emailReg =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


  const antIcon = (
    <LoadingOutlined
      style={{ fontSize: 14, color: "white", marginRight: "5px" }}
      spin
    />
  );

  // Fetching PAN details
  const fetchPANDetails = async (values) => {
    window?.Moengage?.track_event("add-customer_customer_enter_pan_submit");
    // console.log(values,"xx================");
    try {
      setLoading(true);
      let hash = encodeURIComponent(searchParams.get("hash"));
      const res = await onecodeAPI.post("public/customer/panNumber", {
        // hash: "8ore7hMR8m1vq1agUcUaXcwvTJUaDCBQuTr%2Fs8pIk1VSQ8quKFN6WY%2BpOD5vT8fp60dCUUcW1otePC%2FqA2nK3A%3D%3D",
        hash: hash,
        pan: values.pan,
        email:values.email.trim(),
        employmentType: values.employmentType,
        modeOfIncome: values.modeOfIncome || "0",
        dob: values.dob,
        pinCode: values.pinCode,
      });
      // console.log(res,"panResponse=========")
      if (res.data.status) {
        window?.Moengage?.track_event("add-customer_customer_invalid_pan");
        setPanError(res.data.message);
      } else {
        setCurrentScreen(3);
      }
      setLoading(false);
    } catch (error) {
      if(error?.response?.data?.status==2029){
        setPanError(error?.response?.data?.message);
      }else{
        message.error("Error","Please try again after some time.")  
      }
      setLoading(false);
      // setPanError("Something went wrong");
      console.log("error-pan", error);
    }
  };

  // PAN Input
  const handlePanChange = (e) => {
    if (e.target.value.length >= 10) {
      if (panRegex.test(e.target.value.toUpperCase())) {
        setIsPan(true);
      } else setIsPan(false);
      setPan(e.target.value);
      setPanError("");
    } else {
      setIsPan(false);
      setPan(e.target.value);
      setPanError("");
    }
  };
  const numberReg = /^[1-9]{1}[0-9]{5}$/;
  const panSchema = Yup.object({
    pan: Yup.string()
      .matches(panRegex, "*Invalid PAN format")
      .required("Required"),
    email: Yup.string().trim()
    .matches(emailReg, "Invalid Email Format")
    .required("Email Required"),
    employmentType: Yup.string().required("Required"),
    modeOfIncome: selectedEmploymentType == "4" ? Yup.string() : Yup.string().required("Required"),
    dob: Yup.string().trim().nullable().required("Required"),
    pinCode: Yup.string()
      .matches(numberReg, "Invalid pincode")
      .test("", "Invalid pincode", (value) =>
        searchedPincodeList?.includes(value)
      )
      .required("Required"),
  });

  const criteriaFieldsStates = {
    income: (v) => {},
    employmentType: (v) => setEmploymentTypeOptions(v),
    modeOfSalary: (v) => setModeOfSalaryOptions(v),
    currentOccupation: (v) => {},
    category: (v) => {},
    experian: () => {},
    age: () => {},
    Equifax: () => {},
    CIBIL: () => {},
    Experian: () => {},
    dpd: () => {},
    creditHistory: () => {},
    bankName: () => {},
    workExperience: () => {},
  };

  const fetchFields = async () => {
    try {
      const res = await onecodeAPI.get(`/criteria/fields?locale=${i18n?.language || "en"}`);
      // console.log(res.data, "res");
      _.forEach(res.data, (criteria) => {
        criteriaFieldsStates[criteria?.criteriaName](criteria.indexes);
      });
      setHasCriteriaFields(true);
    } catch (error) {
      setLoading(false);
      console.log("error-field", error);
    }
  };

  useEffect(() => {
    fetchFields();
  }, []);

  const formik = useFormik({
    initialValues: {
      pan: "",
      email:"",
      employmentType: "",
      modeOfIncome: "",
      dob: "",
      pinCode:""
    },
    validationSchema: panSchema,
    onSubmit: (values) => {
      // console.log("x=======")
      if(!loading){
      fetchPANDetails(values);
      }
    },
  });

  return (
    <div>
      {/* <div className="panInputContainer">
        <input
          placeholder={t("pannumbersubmitpage.enterpannumber")}
          onChange={handlePanChange}
          value={pan?.toUpperCase()}
          style={{
            width: "45%",
            fontSize: "0.8rem",
          }}
        />
        <button
          disabled={
            isPan && pan.length === 10 && creditReportCheck ? false : true
          }
          onClick={fetchPANDetails}
          style={{
            backgroundColor:
              isPan && pan.length === 10 && creditReportCheck
                ? "#6C63FF"
                : "#999999",
            color: "white",
            padding: "5px 23px 5px 23px",
            borderRadius: "8px",
            border: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "45%",
          }}
        >
          {" "}
          {loading && <Spin indicator={antIcon} />}
          {t("addcustomertotalinformation.Submit")}
        </button>
      </div>

      {!isPan && pan.length >= 10 && (
        <p
          style={{
            color: "red",
            fontSize: 12,
            // borderWidth: 1,
            width: "90%",

            paddingLeft: 5,
            paddingTop: 5,
            margin: "1px auto",
          }}
        >
          *Invalid PAN
        </p>
      )} */}

      {/* <div
        className="termsContainer"
        onClick={() => setCreditReportCheck(!creditReportCheck)}
      >
        <input
          type="checkbox"
          style={{
            width: "18px",
            height: "18px",
            backgroundColor: "red",
          }}
          checked={creditReportCheck}
        />
        <div>I authorize to pull the Credit Report</div>
      </div>
      {!creditReportCheck && (
        <div
          style={{
            color: "red",
            fontSize: "0.8rem",
            width: "70%",
            margin: " 1px auto",
            paddingLeft: "15px",
            marginTop: "-10px",
          }}
        >
          Please authorize to pull the Credit Report
        </div>
      )} */}

      {/* <div className="WatchVideo">
        <BsPlayCircle className="videoLogo" />
        <p className="videoText">Why PAN number?</p>
      </div> */}
      <div
        style={{
          backgroundColor: "transparent",
          marginTop: "50px",
        }}
      >
        <form
          onSubmit={formik.handleSubmit}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            //   border: "1px solid red",
            width: "100%",
            // marginTop: "50px",
            backgroundColor: "",
            margin: "0 auto",
            marginLeft: "2%",
          }}
        >
          <div
            style={{
              margin: "0 auto",
              // border: "1px solid red",
              width: "90%",
              marginBottom: "5px",
              marginLeft: "2.7%",
            }}
          >
            {/* {console.log(formik.errors)} */}
            <CustomInput
              label={t("addcustomertotalinformation.pannumber")}
              handleChange={(event) => {
                formik.setFieldValue("pan",event?.target?.value?.toUpperCase())
              }}
              handleBlur={formik.handleBlur}
              value={formik.values.pan}
              name="pan"
              readonly={false}
            />
            {formik.touched.pan && formik.errors.pan ? (
              <div
                className="error"
                style={{ paddingLeft: "17px", marginBottom: "-10px" }}
              >
                {formik.errors.pan}
              </div>
            ) : null}
            {panError ? (
              <p
                className="error"
                style={{ paddingLeft: "17px", marginBottom: "-10px" }}
              >
                {panError}
              </p>
            ) : (
              <span />
            )}
          </div>
          {/* ************************************************************* */}
          <div
            style={{
              margin: "0 auto",
              // border: "1px solid red",
              width: "90%",
              marginBottom: "5px",
              marginLeft: "2.7%",
            }}
          >
          <CustomInput
              label={"Email"}
              handleChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              value={formik.values.email}
              name="email"
            />
            {formik.touched.email && formik.errors.email ? (
              <div
                className="error"
                style={{ paddingLeft: "17px", marginBottom: "-10px" }}
              >
                {formik.errors.email}
              </div>
            ) : null}
          </div>
          {/* ******************************************************************* */}
          <div
            style={{
              margin: "0 auto",
              // border: "1px solid red",
              width: "90%",
              paddingLeft: "",
              marginBottom: "5px",
              marginLeft: "7%",
            }}
          >
            <DropDown
              data={employmentTypeOptions}
              label={t("addcustomertotalinformation.employmenttype")}
              handleChange={(option) =>{
                formik.setFieldValue("employmentType", option.value);
                setSelectedEmploymentType(option.value);
              }}
              handleBlur={formik.handleBlur}
              value={formik.values.employmentType}
              name="employmentType"
            />
            {formik.touched.employmentType && formik.errors.employmentType ? (
              <div
                className="error"
                style={{ marginLeft: "13px", marginBottom: "-10px" }}
              >
                {formik.errors.employmentType}
              </div>
            ) : null}
          </div>
          <div
            style={{
              margin: "0 auto",
              // border: "1px solid red",
              width: "90%",
              paddingLeft: "",
              marginLeft: "7%",
              // background:"grey"
            }}
          >
            <DropDown
              data={modeOfSalaryOptions}
              label={t("addcustomertotalinformation.modeofincome")}
              handleChange={(option) =>
                formik.setFieldValue("modeOfIncome", option.value)
              }
              handleBlur={formik.handleBlur}
              // value={formik.values.modeOfIncome}
              name="modeOfIncome"
              value={
                formik.values.employmentType == 4
                  ? "0"
                  : formik.values.modeOfIncome
              }
              disable={formik.values.employmentType == 4 ? true : false}
            />
            {formik.touched.modeOfIncome && formik.errors.modeOfIncome ? (
              <div
                className="error"
                style={{ marginLeft: "13px", marginBottom: "-5px" }}
              >
                {formik.errors.modeOfIncome}
              </div>
            ) : null}
          </div>
          <div
            style={{
              margin: "0 auto",
              // border: "1px solid red",
              width: "90%",
              marginBottom: "5px",
              marginLeft: "2.7%",
            }}
          >
            <CustomInput
              label={t("addcustomertotalinformation.dob")}
              type="date"
              handleChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              value={formik.values.dob}
              name="dob"
              readonly={false}
              // style={{input:focus:placeholder""}}
            />
            {formik.touched.dob && formik.errors.dob ? (
              <div className="error">{formik.errors.dob}</div>
            ) : null}
          </div>
          <div
            style={{
              margin: "0 auto",
              // border: "1px solid red",
              width: "90%",
              marginBottom: "5px",
              marginLeft: "2.7%",
            }}
          >
            <CustomInput
              label={t("addcustomertotalinformation.pincode")}
              handleChange={(option) => {
                formik.setFieldValue("pinCode", option);
              }}
              handleBlur={formik.handleBlur}
              value={formik.values.pinCode}
              name="pinCode"
              readonly={false}
              text="number"
              setSearchedPincodeList={setSearchedPincodeList}
            />
            {formik.touched.pinCode && formik.errors.pinCode ? (
              <div className="error">{formik.errors.pinCode}</div>
            ) : null}
          </div>
          <button
            type="submit"
            style={{
              // background: termsChecked ? "#6C63FF" : "#c2c2c2",
              backgroundColor: "#6C63FF",
              border: "none",
              color: "white",
              padding: 12.5,
              borderRadius: 5,
              margin: "auto",
              width: "45%",
              marginTop: "20px",
              boxShadow: "0px 0px 34px rgba(174, 174, 174, 0.3)",
            }}
            disabled={
              (formik.errors.employmentType &&
              formik.errors.employmentType &&
              formik.errors.modeOfIncome) || loading
            }
          >
            {loading && <Spin indicator={antIcon} />}
            {t("addcustomertotalinformation.Apply")}
          </button>
        </form>
      </div>
      <div
        style={{
          width: "90%",
          background: "#ECEFF5",
          borderRadius: "5px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: "10px auto",
          padding: "10px",
        }}
      >
        <img
          src={pic}
          alt=""
          style={{
            width: "48px",
            heigth: "48px",
          }}
        />
        <div
          style={{
            // border: "1px solid red",
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
            justifyContent: "flex-start",
            marginLeft: "15px",
          }}
        >
          <h2
            style={{
              fontSize: "16px",
              color: "#9B9B9B",
            }}
          >
            {t("pannumbersubmitpage.DataIsProtected")}
          </h2>
          <p
            style={{
              fontSize: "13px",
              color: "#A0A0A0",
              marginTop: "-10px",
            }}
          >
            {t("pannumbersubmitpage.YourCustomersDataIsSafeWithUs")}
          </p>
        </div>
      </div>
      <div>
        <WatchVideo
          videoTitle={t("pannumbersubmitpage.panConsent")}
          videoId={isMyTeamsFlow ? t("pannumbersubmitpage.myTeamsVideoId") : t("pannumbersubmitpage.videoId")}
          name={"Why PAN number?"}
          eventName={"add-customer_customer_why_pan_video"}
          currentScreen={currentScreen}
          thumbnail={
            "https://onecode-asset.s3.ap-south-1.amazonaws.com/Pan_Important_Thumbnail_customer.jpg"
          }
        />
      </div>
    </div>
  );
}